import { ApiConfig } from '../app/models/api.models';

export const environment = {
    production: true,
    api: {
        baseUrl: 'https://servicesapi.telaffuz.org/api/', // Production API URL
        adminBaseUrl: 'https://servicesapi.telaffuz.org/api/', // Admin API endpoints
        gameBaseUrl: 'https://servicesapi.telaffuz.org/api/', // Game API endpoints
        language: 'tr' // Default language
    } as ApiConfig
};
